import {joinUrl} from "../../Utilities/UriUtilities";
import {acceptHeader, executeWithErrorResponseHandling} from "../ApiUtilities";
import axios from "axios";
import {isRequestError, RequestError} from "../../Model/RequestError";
import {CarouselContentType} from "../../Model/Sales/CarouselContentType";
import {CarouselContentItem} from "../../Model/Sales/CarouselContentItem";
import {COUNTER_API_CALLS} from "../../Service/CounterMetricsProvider";

export const fetchCarouselContent = async (
    domain: string,
    reseller: string,
    carouselContentType: CarouselContentType,
): Promise<CarouselContentItem[] | RequestError> => {
    const endPoint = joinUrl(domain, `/${reseller}/carousel/content/${carouselContentType}`)
    const headers = acceptHeader()

    const response = await executeWithErrorResponseHandling<any>(() =>
        axios.get(endPoint, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/carousel/content/{carouselContentType}", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/carousel/content/{carouselContentType}", "status": "success"}})
        return response.data
    }
}